import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CustomerDecisionPage.DecisionMakerForm', {
    firstNameFieldTitle: 'First name',
    lastNameFieldTitle: 'Last name',
    titleFieldTitle: 'Job title',
    companyFieldTitle: 'Company name',
    commentFieldTitle: 'Comment',
    fieldsPlaceholder: 'Enter...',
    approveButtonText: 'Accept',
    approveButtonTitle: 'Accept',
    rejectButtonText: 'Decline',
    rejectButtonTitle: 'Decline',
    sectionTitle: 'Decision maker signature',
});
